import type { PlayerData } from '../../components/PlayersStats/PlayersStats.types';

const sortInjuredPlayersData = (player1: PlayerData, player2: PlayerData) => {
  if (player1.injuryStatus === player2.injuryStatus) {
    return 0;
  }

  if (player1.injuryStatus === 'missing') {
    return -1;
  }

  return 1;
};

export default sortInjuredPlayersData;
